import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=8e50d632&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e50d632')) {
      api.createRecord('8e50d632', component.options)
    } else {
      api.reload('8e50d632', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=8e50d632&", function () {
      api.rerender('8e50d632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UJ7l0j7NZryz/JS/comp/ServiceHelp.vue"
export default component.exports